//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/ScCollector.js";
import "../no/ScCollector.js";
let d=[[[1,"Face",0,"ScCollector",0],[0,"Translucency",1,0]],[[[],"GetFaceColor",{R_:{faceColor:''}},0,0],[["faceColor"],"SetFaceColor",{},1,0],[[],"InitializeGeometry",{},0,0],[["selNode"],"CreateNewSubNode",{},1,0],[["initialize_way"],"InitializeContent",{},1,0]],[]];
SPLM.Tooling.ManufacturingGeometryBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.ManufacturingGeometryBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;